<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div ref="wyGenaricTable" class="wy-genaric-table" v-if="!(this.tableDataResults.length > 0 && tableData.length == 0)">
    <div class="wy-table-wrapper" style="width: 100%; overflow-x: hidden;" :class="tableClass">
      <div v-if="tableData && tableData.length > 0 && iShowTable">
        <!-- Main columns table -->
        <table border="0" class="wy-table-main">
          <thead>          
            <tr ref="wyHeaderMain" class="wy-header" :style="{'left': scrollLeft + 'px'}">
              <th v-for="(group, index) in groupColumns" :key="index" :colspan="group.headerSpan" 
                  v-bind:style="{'min-width': (group.fixed?'320':group.headerWith)+'px', 'text-align': group.align}">
                <span v-if="group.type!='index' && group.type!='selection' && group.name !== 'target'">{{group.label}}</span>
                <span v-else-if="group.type!='index' && group.type!='selection' && tableData && tableData.length > 0 && iShowTable" >{{group.label}}</span>
              </th>
              <th class="wy-table-tail"><br></th>
            </tr>
            <tr v-if="hasSubtitle" ref="wySubheaderMain" class="wy-sub-header" :style="{'left': scrollLeft + 'px'}">
              <th v-for="(column, index) in allColumns" :key="index" 
                  v-bind:class="{'lastChild': column.lastChild, 'sortable': column.sortable, 'sorted': sortedColumnName==column.sortBy,'ascending': sortedType^sortCaretHovered==0, 'descending': sortedType^sortCaretHovered==1}" 
                  v-bind:style="{'min-width': (column.fixed?'320':column.minWidth)+'px'}" @click="handleSort(column)" 
                  @mouseenter="toggleSortCaretHovered(column.sortBy)" @mouseleave="toggleSortCaretHovered(column.sortBy)">
                <span v-if="column.type!='index'">{{column.label}}</span>
              </th>
              <th class="wy-table-tail"><br></th>
            </tr>        
          </thead>
          <tbody  ref="wyTableBodyMain" class="wy-body"  @mousewheel="handleMousewheelOnMainTable" @scroll="handleScrollingOnMainTable">
            <tr v-for="(row, index) in tableData" :key="index" @click="handleClick($event, index, row)" @mouseover="handleMouseover" @mouseleave="handleMouseleave" :class="{'highlightedRow': index == highlightedIndex}">
              <td v-for="(column, columnIndex) in allColumns" :key="columnIndex" v-bind:style="{'min-width': (column.fixed?'320':column.minWidth)+'px', 'text-align': column.align}" 
                  :class="{'last-child': column.lastChild, 'align-right': column.align=='right'}">
                <!-- empty column (if it's part of the fixed columns) since it will be rendered in fixed column -->
                <div v-if="column.fixed"></div>
                <!-- index column -->
                <div v-else-if="column.type=='index'"></div>
                <!-- icon column -->
                <div v-else-if="column.type=='icon'"></div>
                <!-- html column -->
                <div v-else-if="column.type=='html'">
                  <div v-html="row[column.name]"></div>
                </div>
                <!-- trend column -->
                <div v-else-if="column.type=='trend'">
                  <div v-html="row['trendChart']"></div>
                </div>
                <div v-else-if="column.name=='target'">
                  <div v-html="getTarget(row.name)"></div>
                </div>
                <div v-else-if="column.name=='dynamicFields'">
                </div>
                <!-- no data column -->
                <div v-else-if="row[column.name]==null || row[column.name]=='NaN' || row[column.name]=='+Infinity'" :class="column.cssClass">
                  <div class="el-no-data" @mouseover="handleTooltipOver($event, noDataMsg)" @mouseout="handleTooltipOut($event)"></div>
                </div>
                <!-- % change column -->
                <div v-else-if="column.type=='percentChange'">
                  <span v-if="column.prefix">{{column.prefix}}</span>
                  <span v-html="cellFormatter(row[column.name])" @mouseover="handleTooltipOver($event, row[column.tooltipMessage])" @mouseout="handleTooltipOut($event)" :class="{'positive-change':row[column.name]>0,'negative-change':row[column.name]<0,'zero-change':row[column.name]==0}"></span>
                  <span v-if="column.suffix">{{column.suffix}}</span>
                </div>
                <!-- tooltip column -->
                <div v-else-if="column.tooltipMessage" @mouseover="handlePopoverOver($event, row[column.tooltipMessage])" @mouseout="handlePopoverOut($event)">
                  <span v-if="column.prefix">{{column.prefix}}</span>
                  <span v-html="cellFormatter(row[column.name])"></span>
                  <span v-if="column.suffix">{{column.suffix}}</span>
                </div>
                <!-- the column with status icon -->
                <div v-else-if="column.hasIcon" :class="column.cssClass">
                  <span v-if="column.prefix">{{column.prefix}}</span>
                  <span v-if="isShowIcon(row[column.name + 'Raw'], row['rowKey'])=='green'" class="icon-green-check"></span>
                  <span v-if="isShowIcon(row[column.name + 'Raw'], row['rowKey'])=='red'" class="icon-red-warning"></span>
                  <div v-html="cellFormatter(row[column.name])"></div>
                  <span v-if="column.suffix">{{column.suffix}}</span>
                </div>
                <div v-if="column.type=='targetRange'">
                  <!-- <wy-target-number-range v-if="row[column.name]&&Object.keys(row[column.name]).length>1" :lessThan="row[column.name].lessThan" :greaterThan="row[column.name].greaterThan" /> -->
                  <span v-if="row[column.name].prefix">{{row[column.name].prefix}}</span>
                  <wy-target-number-range v-if="row[column.name]&&Object.keys(row[column.name]).length>0" :controller="module" :rowIndex="index" :tableData="tableData" :columnName="column.name" :data="tableData[index][column.name]" />
                  <span class="company-target-suffix" v-if="row[column.name].suffix">{{row[column.name].suffix}}</span>
                  <span class="cancel-target el-icon-close" @click="removeTargetValue(row[column.name])"></span>
                </div>
                <!-- normal column -->
                <div v-else :class="column.cssClass">
                  <span v-if="column.prefix">{{column.prefix}}</span>
                  <span v-html="cellFormatter(row[column.name])"></span>
                  <span v-if="column.suffix">{{column.suffix}}</span>
                </div>
              </td>
              <td class="wy-table-tail"><br></td>
            </tr>
          </tbody>
        </table>

        <!-- Fixed not movable columns overlay table -->
        <table border="0" class="wy-table-fixed" v-bind:class="{'show-fixed-table-shadow': scrollLeft < -1}">
          <thead>
            <tr class="wy-header">
              <th class="fixed" v-for="(group, index) in groupFixedColumns" :key="index" :colspan="group.headerSpan" 
                  v-bind:style="{'min-width': (group.fixed?'320':group.headerWith)+'px'}">
                <span v-if="group.type!='index' && group.type!='selection' && group.name !== 'target'">{{group.label}}</span>
                <span v-else-if="group.type!='index' && group.type!='selection' && tableData && tableData.length > 0 && iShowTable" >{{group.label}}</span>
              </th>
            </tr>
            <tr v-if="hasSubtitle" class="wy-sub-header">
              <th v-for="(column, index) in fixedColumns" :key="index" v-bind:class="fixedTableHeaderClasses(column)"
                  v-bind:style="{'min-width': (column.name=='topicDisplayName'?'320':column.minWidth)+'px'}"  @click="handleSort(column)" 
                  @mouseenter="toggleSortCaretHovered(column.sortBy)" @mouseleave="toggleSortCaretHovered(column.sortBy)">
                <el-checkbox v-if="column.type=='selection'" ref="headerCheckbox" @change.native="handleSelectAll" :indeterminate="selectedRowsNum > 0 && selectedRowsNum < tableModel.results.length" :checked="selectedRowsNum == tableModel.results.length"/>
                <span v-else-if="column.type!='index'">{{column.label}}</span>
              </th>
            </tr>        
          </thead>
          <tbody ref="wyTableBodyFixed" class="wy-body" @mousewheel="handleMousewheelOnFixedTable" @scroll="handleScrollingOnFixedTable">
            <tr v-for="(row, index) in tableData" :key="index" @click="handleClick($event, index, row)" @mouseover="handleMouseover" @mouseleave="handleMouseleave" :class="{'highlightedRow': index == highlightedIndex,}">
              <td class="fixed" v-for="(column, columnIndex) in fixedColumns" :key="columnIndex" :class="{'last-child': column.lastChild}"
                v-bind:style="{'min-width': (column.fixed?'320':column.minWidth)+'px', 'max-width': (column.fixed?'320':column.minWidth)+'px','text-align': column.align}">
                <!-- index column -->
                
                <div v-if="column.type=='index'">
                  {{index+1}} 
                </div>

                <div :class="(getTarget(row.name) == '-'? 'target-dash-style':'')" v-else-if="column.name=='target'">
                  <div v-html="getTarget(row.name)"></div>
                </div>
                
                <!-- selection column -->
                <div v-else-if="column.type=='selection'">
                  <el-checkbox v-model="row.isSelected" @change.native="handleSelect" @click.native="handleSelectStopPropagation"/>
                </div>
                <!-- icon column -->
                <div v-else-if="column.type=='icon'">
                  <div v-if="row[column.name].icon != ''" class="wy-table-icon" v-bind:style="{'background-image': row[column.name].icon}" 
                    @mouseover="handlePopoverOver($event, row[column.name].toolTips)" @mouseout="handlePopoverOut($event)">
                    <div v-if="row[column.name].value>=1000" class="icon-number small-font">....</div>
                    <div v-else class="icon-number" v-bind:class="{'small-font': (row[column.name].value>=100 && row[column.name].value<1000)}">{{row[column.name].value}}</div>
                  </div>
                </div>
                <div v-else>
                  <span v-if="column.prefix">{{column.prefix}}</span>
                    <span v-if="!indentList.includes(row[column.name])">{{row[column.name]}}</span>
                    <span v-else class="has-indent">{{row[column.name]}}</span>
                  <span v-if="column.suffix">{{column.suffix}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="no-result-found">
        <div class="no-data"></div>
        <div class="no-data-title">{{$t('noResultFound.title')}}</div>
        <div class="no-data-content">
          <div class="content-text">
            {{$t('noResultFound.message')}}
          </div>
        </div>
      </div>
    </div>

    <el-tooltip
      ref="tableTooltip"
      placement="bottom"
      effect="dark"
      :content="tableTooltipContent">
    </el-tooltip>

    <el-popover
      ref="tablePopover"
      placement="bottom"
      title=""
      trigger="hover"      
      popper-class="wy-table-change-popover"
      :content="tablePopoverContent">
    </el-popover>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import wyTargetNumberRange from './wy-target-number-range';

export default {
  name: 'wy-genaric-table',
  props: ['controller', 'enableSelection', 'rowClickEvent', 'defaultSort','hasSubtitle', 'tableColumns', 'tableDataResults', 'mode', 'tableName', 'noDataMsg'],

  components: {
    'wy-target-number-range': wyTargetNumberRange
  },
  
  data() {
    return {
      module: this,
      iShowTable: false,
      groupColumns: null,
      groupFixedColumns: null,
      sortedColumnName: null,
      sortedType: 1,
      sortCaretHovered: 0,
      tablePopoverContent: null,
      tableTooltipContent: null,
      highlightedIndex: null,
      scrollLeft: 0,
      selectedRowsNum: 0,
      allColsWidth: -1,
      variableColWidth: 350,
      minWidth: 320,


      targetType: '',
      tableClass: '',
      indentList: [
                    'Received positive feedback', 
                    'Received negative feedback', 
                    'Customer requested handoff', 
                    'Automatic handoff after intent-based trigger', 
                    'Candidates for new intents', 
                    'Candidates for existing intents'
                  ]
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'companyConfig']),

    fixedColumns() {
      return this.allColumns.filter((item) => item.fixed)
    },

    allColumns() {
      let list = [];
      if(this.groupColumns) {
        this.groupColumns.forEach(group => {
          let currGroup = group.columns.filter(el => el.selected);
          for (let i = 0; i < currGroup.length-1; i ++)
            currGroup[i].lastChild = false;
          if (currGroup.length)
            currGroup[currGroup.length-1].lastChild = true;
          list = list.concat(currGroup);
        })
      }
      return list;
    },

    tableData() {
      let list = null;
      let tableResults = [];
    
      let hideMetrics = this.companyConfig ? ((this.companyConfig.optimization || {}).hideMetrics || []) : [];
      let tableKey = (this.tableColumns && this.tableColumns.length > 0) ?this.tableColumns[0].name : "";

      if(this.mode && this.mode == 'generic') {
        tableResults = this.tableDataResults.filter(item => {
          return !hideMetrics.includes(item[tableKey])
        });
      }
      else {
        tableResults = this.tableModel.results.filter(item => {
          return !hideMetrics.includes(item[tableKey])
        });
      }
      list = tableResults;
      return list;
    }
  },

  watch: {
    'dataModel.keyword': function() {
      this.clearSelection();
    }
  },

  mounted: function() {
    if(this.$refs.wyGenaricTable) {
      this.resizeObserver = new ResizeObserver(this.handleWindowResize).observe(this.$refs.wyGenaricTable);
    }
  },

  updated: function() {
    this.handleWindowResize();
  },

  methods: {
    ...mapMutations(['updateTableModelSelectedRows']),

    handleClick() {
      // do nothing
    },

    cellFormatter(value) {
      if(typeof value == "number") {
        value = WyUtils.formatterNumber(value);
      }
      return value;
    },

    fixedTableHeaderClasses(column) {
      let classes = {'lastChild': column.lastChild, 'sortable': column.sortable, 'fixed': true, 'sorted': this.sortedColumnName==column.sortBy, 
          'ascending': this.sortedType^this.sortCaretHovered==0, 'descending': this.sortedType^this.sortCaretHovered==1};
      classes[column.name] = true;
      return classes;
    },

    handleSort({sortBy, sortType}) {
      if(sortType != null) {
        this.sortedColumnName = sortBy;
        this.sortedType = sortType;
        return;
      }
      if(this.sortedColumnName != sortBy) {
        this.sortedType = 1;  
      }
      else {
        this.sortedType = this.sortedType==0 ? 1 : 0;
      }
      if (this.sortedColumnName != sortBy) {
        this.sortedColumnName = sortBy;
        this.sortCaretHovered = 1;
      }
    },

    handleSelect(e) {
      e.preventDefault();
      e.stopPropagation();
      let selectedRows = this.tableData.filter(item => item.isSelected);
      this.updateTableModelSelectedRows(selectedRows);
      this.selectedRowsNum = selectedRows.length;
    },

    handleSelectStopPropagation(e) {
      e.stopPropagation();
    },

    handleSelectAll(e) {
      e.preventDefault();
      e.stopPropagation();
      let selectedRows = this.tableData.filter(item => {item.isSelected=e.target.checked; return item.isSelected});
      this.updateTableModelSelectedRows(selectedRows);
      this.selectedRowsNum = selectedRows.length;
    },

    clearSelection() {
      let selectedRows = this.tableData.filter(item => {item.isSelected=false; return false});
      this.updateTableModelSelectedRows(selectedRows);
      this.selectedRowsNum = 0;
    },

    handlePopoverOver(e, content) {
      this.$refs.tablePopover.doClose();
      this.tablePopoverContent = content;
      this.$refs.tablePopover.referenceElm = e.target;
      setTimeout(() => {
        this.$refs.tablePopover.doShow();
      }, 300)
    },

    handlePopoverOut() {
      this.tablePopoverContent = null;
      this.$refs.tablePopover.referenceElm = null;
      this.$refs.tablePopover.doClose();
    },

    handleTooltipOver(e, content) {
      this.$refs.tableTooltip.hide();
      this.$refs.tableTooltip.handleClosePopper();
      this.$refs.tableTooltip.referenceElm = e.target;
      this.tableTooltipContent = (!content || content=='') ? 'No data' : content;
      setTimeout(() => {
          this.$refs.tableTooltip.show();
          this.$refs.tableTooltip.handleShowPopper();
          setTimeout(()=>{
            if (this.$refs.tableTooltip.$refs.popper.getBoundingClientRect().x < 0) {
              this.$refs.tableTooltip.hide();
              this.$refs.tableTooltip.handleClosePopper();
            }
          }, 3)
      }, 100)
    },

    handleTooltipOut() {
      this.$refs.tableTooltip.hide();
      this.$refs.tableTooltip.handleClosePopper();
    },

    handleMousewheelOnMainTable(e) {
      // e.preventDefault();
      // e.stopPropagation();
      this.$refs.wyTableBodyFixed.scrollTop += e.deltaY;  // y scroll fixed overlay table
      this.$refs.wyTableBodyMain.scrollTop += e.deltaY;  // y scroll main table
      this.$refs.wyTableBodyMain.scrollLeft += e.deltaX;  // x scroll main table
      this.scrollLeft = Math.max(0, this.$refs.wyTableBodyMain.scrollLeft) * -1;  // x scroll main header
    },

    handleMousewheelOnFixedTable(e) {
      // e.preventDefault();
      // e.stopPropagation();
      this.$refs.wyTableBodyFixed.scrollTop += e.deltaY;  // y scroll fixed overlay table
      this.$refs.wyTableBodyMain.scrollTop += e.deltaY;  // y scroll main table
    },

    handleScrollingOnMainTable(e) {
      // x scroll fixed overlay table with main table
      this.scrollLeft = e.target.scrollLeft * -1;
      // y scroll fixed overlay table with main table
      this.$refs.wyTableBodyFixed.scrollTop = e.target.scrollTop;
    },

    handleScrollingOnFixedTable(e) {
      // Handles the case where the fixed table is scrolled when user searchers keyword using Ctrl + F
      this.$refs.wyTableBodyMain.scrollTop = e.target.scrollTop;
    },

    handleMouseover() {
      // this.highlightedIndex = e.target.closest('tr').sectionRowIndex;
    },

    handleMouseleave() {
      // this.highlightedIndex = null;
    },

    toggleSortCaretHovered(columnName) {
      if (columnName == this.sortedColumnName)
        this.sortCaretHovered = 1 - this.sortCaretHovered;
    },

    refreshTable() {
      // preapare selected columns
      // this.handleSort({sortBy: this.defaultSort.name, sortType: this.defaultSort.type});
      
      let groupMap = {};
      let tableColumns1 = [];
      tableColumns1 = this.tableColumns;
      tableColumns1.forEach(column => {
        column.sortBy = column.sortBy || column.name;
        column.selected = true;   //default selected all columns
        if(column.groupHidden) {
          if(column.selected) {
            groupMap[column.group] = column;
          }
        }
        else {
          if(!groupMap[column.group]) {
            groupMap[column.group] = {
              label: column.group,
              name: column.group.replace(' ', '-').toLowerCase(),
              columns: [],
              type: column.type,
              isIndeterminate: false,
              fixed: column.fixed,
              width: column.minWidth,
              hasIcon: column.hasIcon,
              cssClass: column.cssClass,
              align: column.align,
              checked: false
            };
          }

          if(column.selected) {
            groupMap[column.group].columns.push(column);
            // // add children
            // if(!column.parent) {
            //   this.dataModel.columns.filter(el => el.parent==column.name).forEach(childColumn => {
            //     groupMap[column.group].columns.push(childColumn);
            //   });
            // }
          }
        }        
      });
      let groupList = [];
      let groupFixedList = [];
      Object.keys(groupMap).forEach(key => {
        let group = groupMap[key];
        if((group.columns == undefined || group.columns.length > 0) && group.name!='dynamicfields') {
          // prepare selected colum list
          groupList.push(group);
          
          // calculate the header width and column spans
          group.headerWith = group.columns.reduce((total, item, index) => {total+=item.minWidth+(index>0?20:0); return total;}, 0);
          group.headerSpan = group.columns.filter(el => el.selected).length;
          
          // prepare fixed column list
          let fixedColumns = group.columns.filter((item) => item.fixed);
          if(fixedColumns.length > 0) {
            groupFixedList.push(group)
          }
        }
      });
      this.allColsWidth = 0;
      for (let i = 0; i < groupList.length; i ++) {
        if (!groupList[i].fixed)
          this.allColsWidth += groupList[i].headerWith + 30;
      }
      // this.variableColWidth will be updated in updated() method

      this.controller.loading = true;
      this.iShowTable = false;
      setTimeout(() => {
        this.controller.loading = false;
        this.groupColumns = groupList;
        this.groupFixedColumns = groupFixedList;
        this.iShowTable = true; 
        this.scrollLeft = 0;
      }, 200);
      this.clearSelection();
    },

    handleWindowResize() {
      if(this.$refs.wyTableBodyMain) {
        this.$refs.wyTableBodyFixed.style.height = this.$refs.wyTableBodyMain.clientHeight + "px";
        if (this.allColsWidth >= 0) {
          // The next four lines of code are same as this.variableColWidth = Math.max(350, this.$refs.wyTableBodyMain.clientWidth - this.allColsWidth - 100);
          // except it prevents an oscillation phenomenon in Chrome when there are no other columns and we toggle the sidebar
          // This is done by only updating the variableColWidth when it's different from two steps ago
          let tmp = Math.max(this.minWidth, this.$refs.wyTableBodyMain.clientWidth - this.allColsWidth - 30);
          if (tmp != this.variableColWidthPrev) {
            this.variableColWidthPrev = this.variableColWidth;
            this.variableColWidth = tmp;
          }
        }
      }
    },

    getTarget(rowName) {
      let target = '-';
      if(this.companyConfig && this.companyConfig.optimization && this.companyConfig.optimization.targets) {
        this.getTargetType();
        if(this.targetType != '') {
          let targetObj = this.companyConfig.optimization.targets[this.targetType];
          if(targetObj && targetObj[rowName] && targetObj[rowName].hasOwnProperty("value") && typeof(targetObj[rowName].value) === 'number' && targetObj[rowName].operator){
            let suffix = targetObj[rowName].suffix ? targetObj[rowName].suffix : '';
            target = targetObj[rowName].operator + " " + targetObj[rowName].value + suffix;
          }
        }
      }
      return target;
    },
    
    isShowIcon(value, rowName) {
      let showIcon = "none";
      if(this.companyConfig && this.companyConfig.optimization && this.companyConfig.optimization.targets) {
        this.getTargetType();
        if(this.targetType != '') {
          let targetObj = this.companyConfig.optimization.targets[this.targetType];
          
          if(targetObj && targetObj[rowName] && targetObj[rowName].hasOwnProperty("value") && typeof(targetObj[rowName].value) === 'number' && targetObj[rowName].operator) {
            if(targetObj[rowName].operator == '>' && value > targetObj[rowName].value) {
              showIcon = "green";
            }
            else if(targetObj[rowName].operator == '<' && value < targetObj[rowName].value) {
              showIcon = "green";
            }
            else if(targetObj[rowName].operator == '=' && value == targetObj[rowName].value) {
              showIcon = "green";
            }
            else {
              showIcon = "red";
            }
          }
        }
      }
      return showIcon;
    },
    getTargetType() {
      if(this.controller.targetType) {
        this.targetType = this.controller.targetType;
      }
      else {
        if(this.controller.selectedCompareBy && this.controller.selectedCompareBy != 'date' ) {
          this.targetType = this.controller.selectedCompareBy;
        }
        else if(this.controller.selectedCompareBy && this.controller.selectedCompareBy == 'date' && this.controller.selectedViewDateRange){
          this.targetType = this.controller.selectedViewDateRange;
        }
      }
    },
    removeTargetValue(data) {
      if(data.value) {
        data.value = null
        if(this.controller.controller && typeof this.controller.controller.hasNoSavedChanges != 'undefined') {
          this.controller.controller.hasNoSavedChanges = true
        }
      }
      setTimeout(() => {
        if(typeof this.controller.controller.hasError != 'undefined' && !this.controller.controller.hasError) {
          this.controller.controller.hasError = document.querySelectorAll('.has-error').length > 0;
        }
      }, 200);
    },
  },

  created() {
    this.tableClass = this.tableName ? this.tableName + '-table' : '';
    this.getTargetType();

  }
}
</script>

<style lang="scss">
.has-indent{
  position: relative;
  left: 20px;
}
.target-dash-style{
  margin-left: 17px;
}
.wy-genaric-table {
  width: 100%;
  .wy-body {
    span.cancel-target {
      line-height: 2.3;
      margin-left: 5px;
      cursor: pointer;
    }
    span.company-target-suffix {
      line-height: 2.3;
      margin-left: 5px;
      width: 20px;
    }
  }

  .wy-table-wrapper {
    position: relative;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    background-color: white;
  }

  table {    
    border-spacing: 0px;
    border-collapse: separate;

    font-size: 14px;
  }

  thead {
    display: table;
    table-layout:fixed;
    background-color: #FFF;
    padding: 0px;

    tr{
      display: block;
      th {
        text-align: left;
        color: var(--site-font-secondary-color) !important;
        padding: 9px 10px;
        height: 19px;
        min-height: 19px;
      }
    }

    .wy-header {
      position: relative;
      left: 0px;
      font-size: 15px;
      font-weight: 500;

      th {
        border-right: 1px solid #fff;
        vertical-align: top;
        text-align: center;
      }
    }

    .wy-sub-header {
      position: relative;
      left: 0px;

      th {
        font-size: 13px;
        vertical-align: top;
        text-align: center;
      }
      th.lastChild {
        border-right: 1px solid #fff;
      }
      th.fixed.index label.el-checkbox {
        position: relative;
        bottom: -1px;
      }
      th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
        content: "";
        display: inline-block;
        height: 15px;
        width: 15px;
        position: relative;
        top: 4px;
        left: 4px;
        background-repeat: no-repeat;
      }
      th.sortable.sorted.ascending::after {
        background-image: url('../../assets/icons/icon_sort_asc.svg');
      }
      th.sortable.sorted.descending::after {
        background-image: url('../../assets/icons/icon_sort_des.svg');
      }
      th.sortable.sorted.ascending:hover::after {
        background-image: url('../../assets/icons/icon_hover_arrow_up.svg');
      }
      th.sortable.sorted.descending:hover::after {
        background-image: url('../../assets/icons/icon_hover_arrow_down.svg');
      }
      th.sortable:hover {
        background-color: #d1e5fb;
        cursor: pointer;
        color: #003A5D;
        .sort-caret.ascending {
          background-image: url('../../assets/icons/icon_hover_arrow_up.svg') !important;
        }
        .sort-caret.descending {
          background-image: url('../../assets/icons/icon_hover_arrow_down.svg');
        }
      }
      th.sortable:not(.sorted):hover::after {
        background-image: url('../../assets/icons/icon_hover_arrow_down.svg');
      }
      th:not(.sortable) {
        span {
          padding-left: 0;
        }
      }
    }
  }
  
  tbody {
    display: block;
    .compared-by-chan-tr{
      :nth-child(4){
        min-width: 202px !important;
      }
    }
    tr{
      table-layout: fixed;
      display: block;
      cursor: pointer;

      td {
        padding: 1px 10px;
        height: 60px;
        border-bottom: 1px solid #eee;
        background-color: transparent;

        div {
          display: flex;
          justify-content: center;
        }
      }

      .align-right div {
        // margin-left: auto;
        padding-right: 1px;
      }
      .align-right span {
        margin-left: auto;
        padding-right: 1px;
        width: 42px;
        text-align: center;
      }
        .daily-style span{
          padding-right: 28px !important;
        }
        .compared-by-lang-style span{
          padding-right: 5px !important;
        }
        .compared-by-chan-style span{
          padding-right: 10px !important;
        }
      .wy-table-select .el-checkbox__original {
        margin: 0;
      }

      td.last-child {
        border-right: 1px solid transparent;
        .icon-green-check {
          background-image: url('../../assets/icons/icon-green-check.svg') !important;
          width: 18px;
          background-repeat: no-repeat;
          background-position-y: 3px;
          background-position-x: 2px;
          background-size: 63%;
          
        }
        .icon-red-warning {
          background-image: url('../../assets/icons/icon-red-warning.svg') !important;
          width: 18px;
          background-repeat: no-repeat;
          background-position-y: 2px;
          background-position-x:2px;
          background-size: 60%;
        }
  
        .channel-red-icon-style, .isDaily-red-icon-style{
          padding-right: 0px !important;
        }
        .channel-green-check-style, .isDaily-green-icon-style{
          padding-right: 1px !important;
        }
      }

      td.wy-table-tail {
        padding: 0;
      }
    }
  }

  .highlightedRow td {
    background-color: #f5f7fa !important;
  }

  .wy-table-select {
    min-width: 20px;
    position: relative;
  }

  .wy-table-tail {
    min-width: 22px;
  }
  th.wy-table-tail {
    padding: 9px 7px 9px 10px;
  }

  .wy-table-main {
    width: 100%;
    max-width: 100%;

    thead {
      width: fit-content;
      
      th {
        background-color: #FFF;
        // padding-right: 5px;

      }
      th:last-child, th:nth-last-child(2) {
        border-right: 1px solid transparent;
      }
      th:last-child, th:nth-last-child(1) {
        border-right: 1px solid transparent;
      }
      tr {
        // float: left;  // THIS PLACE IS WHERE SAFARI MESSED UP WHEN YOU ZOOM OUT THE PAGE (BUT CHROME AND FIREFOX DIDN'T)
        width: calc( 100vw - 400px);
        :first-child {
          padding-left: 18px;  // adding the same amt of padding in fixed table
        }
      }
      .wy-header {
        span {
          padding-left: 5px;
        }
        
      }
    }
    tbody { 
      height: calc( 100vh - 245px );
      overflow: auto;
      width: 100%;
      max-width: 100%;
      tr {
        // float: left;  // THIS PLACE IS WHERE SAFARI MESSED UP WHEN YOU ZOOM OUT THE PAGE (BUT CHROME AND FIREFOX DIDN'T)
        width: calc( 100vw - 400px );
        td:first-child {
          padding-left: 20px;  // adding the same amt of padding as in fixed table
        }
        td span.positive-change {
          color: #4448A2;
        }
        td span.negative-change {
          color: #3E6891;
        }
        td span.zero-change {
          color: grey;
        }
      }
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }
  }
  // .wy-table-fixed.show-fixed-table-shadow {
  //   // -webkit-box-shadow: 5px -2px 10px -10px grey; */
  //   /* box-shadow: 5px -2px 10px -10px grey; */
  //   box-shadow: 3px 3px 12px #9d9cc759;
  //   background-color: white;
  //   /* border: 1px solid #ddd; */
  //   padding: 0px 6px;
  // }
  .wy-table-fixed {
    position: absolute;
    top: 0px;
    text-align: center;
    // border-left: 1px solid #eee;
    //z-index: 2;
    thead {
      th:nth-last-child(1) {  // corresponding to name colomn in fixed table
        padding-left: 30px;
        text-align: left !important;
      }
    }
    tbody {
      height: calc( 100vh - 270px);
      overflow: auto;
      -ms-overflow-style: none;  // hiding scrollbar on IE
      scrollbar-width: none;     // hiding scrollbar on Firefox
                                 // see below for Chrome
      width: fit-content;
      td:nth-last-child(1) {    // corresponding to name colomn in fixed table
        padding-left: 30px;
        font-weight: 500;
        div {
          justify-content: flex-start;
        }
      }

      tr td:first-child {
        background-color: #F7F8F8;
        div{
          justify-content: unset !important;
        }
      }
    }
    tbody::-webkit-scrollbar {    // hiding scrollbar on Chrome
      display: none;
    }
    input {
      margin: 3px;
    }
    .total-topic-num {
      font-size: 12px;
    }
  }

  .el-no-data {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_comparison_data_not_available.svg') !important;
    background-size: 7%;
    background-repeat: no-repeat;
    background-position-y: 2px;
    background-position-x: 1px;
    background-color: transparent !important;
    height: 20px;
    width: 20px;
    border: 0px;
    margin-left: 0px;
  }

  .el-no-data:hover {
    background-color: unset;
  }

  .icon-number {
    background-color: #80a6cd;
    border-radius: 10px;
    border: 1px solid #FFF;
    height: 16px;
    width: 16px;
    position: relative;
    top: -10px;
    left: 8px;
    font-size: 9px;
    padding-top: 1px;
    padding-left: 0px;
    line-height: initial;
    color: #FFF;
    text-align: center;
  }

  .small-font {
    font-size: 6px !important;
    padding-top: 3px !important;
  }

  .wy-table-icon {
    display: inline-block;
    width : 25px;
    height: 25px;
    background-repeat: no-repeat;
    background-size: 55%;
    position: relative;
    top: 10px;
  }

  .wy-table-change-popover.el-popover--plain {
      padding: 8px 10px;
      border-radius: 5px;
      background-color: var(--site-font-chart-color);
      color: #FFF;
      font-size: 12px;
    .popper__arrow {
      filter: invert(1);
    }
  }

  .wy-table-alert-popover.el-popover--plain {
    background: #80A6CD;
    color: #FFF;
    border-radius: 10px;
    padding: 5px 10px;
    display: inline-block;
    .popper__arrow {
      display: none;
    }
  }
}
</style>